export default {
  namespaced: true,
  state: () => ({
    appTheme: {
      backgroundWelcome: 'light-blue lighten-1',
      backgroundColor: 'light-blue darken-4',
      components: {
        mainColor: 'light-blue darken-3'
      },
      dragFiles: {
        selectFileButtonColor: 'green accent-4'
      }
    }
  }),
  mutations: {
    SET_APP_THEME(state, appTheme) {
      state.appTheme = appTheme
    }
  },
  actions: {
    setAppTheme({ commit }, appTheme) {
      commit('SET_APP_THEME', appTheme)
    }
  },
  getters: {
    appThemeBackgroundWelcome(state) {
      return state.appTheme.backgroundWelcome
    },
    appThemeBackgroundColor(state) {
      return state.appTheme.backgroundColor
    },
    appThemeComponentsMainColor(state) {
      return state.appTheme.components.mainColor
    },
    appThemeSelectFileButtonColor(state) {
      return state.appTheme.dragFiles.selectFileButtonColor
    }
  }
}
